import { NgModule } from '@angular/core';
import { Role } from '@app/shared/models/user/role';
import { AuthenticationManagerService, TkAuthModule } from '@technocom/auth';
import { MainMenuService, TkCoreModule, UserMenuService } from '@technocom/core';

@NgModule({
  providers: [],
  imports: [TkCoreModule, TkAuthModule],
})
export class CoreMenuModule {
  constructor(menu: MainMenuService, userMenu: UserMenuService, authService: AuthenticationManagerService) {
    menu.add([
      {
        id: 'master',
        text: 'Главная',
        localeText: 'dashboard.home',
        link: '/',
        matching: 'exact',
        children: [
          {
            id: 'information',
            text: 'Жизненные ситуации',
            localeText: 'dashboard.inf_mat',
            link: '/information',
            className: 'menu-icon app-shortcut-module__inf_mat',
            matching: 'exact',
          },
          {
            id: 'verification',
            text: 'Полезные сервисы',
            localeText: 'dashboard.docs',
            link: '/verification',
            matching: 'exact',
            className: 'menu-icon app-shortcut-module__documents',
          },
          {
            id: 'organizations',
            text: 'Путеводитель мигранта',
            localeText: 'dashboard.mig_help',
            link: '/organizations',
            matching: 'exact',
            className: 'menu-icon app-shortcut-module__assist',
          },
          {
            id: 'logs',
            text: 'Журналирование',
            link: '/logs',
            matching: 'exact',
            className: 'menu-icon app-shortcut-module__logs',
            authorities: [Role.DATA_ADM],
          },
          {
            id: 'news',
            text: 'Новости',
            localeText: 'dashboard.news',
            link: '/news',
            matching: 'exact',
            className: 'menu-icon app-shortcut-module__news',
          },
          {
            id: 'mobile-app',
            text: 'Мобильное приложение',
            localeText: 'dashboard.mob_app',
            link: '/mobile-app',
            matching: 'exact',
            className: 'menu-icon app-shortcut-module__mobile',
          },
          {
            id: 'reports',
            text: 'Отчеты',
            link: '/reports',
            matching: 'exact',
            className: 'menu-icon app-shortcut-module__reports',
            authorities: [Role.OPR],
          },
          {
            id: 'education',
            text: 'Обучение мигрантов',
            localeText: 'dashboard.education',
            link: '/education',
            matching: 'exact',
            className: 'menu-icon app-shortcut-module__courses',
            authorities: [Role.LECTOR],
          },
        ],
      },
    ] as any[]);
    userMenu.add([
      {
        text: 'Отладочная информация',
        link: '/about',
        authorities: Role.USER_ADM,
      },
      {
        text: 'Личный кабинет',
        link: '/profile',
        hidden: authService.hasLoginMethods() !== true,
        authorities: [Role.MIGRANT],
      },
      {
        text: 'Выход',
        link: '/logout',
        hidden: authService.hasLoginMethods() !== true,
        authorities: true,
      },
    ]);
  }
}
